import React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { useHeroContext } from "../contexts/hero-context";
import {
  cn,
  headerNavTextClass,
  headerShellHorizontalInsetClass,
} from "../util";

const Header = () => {
  const location = useLocation();
  const { showContent } = useHeroContext();
  const isIndexPage = location.pathname === "/";

  return (
    <>
      <header
        className={cn(
          "fixed left-0 top-0 z-50 flex w-full",
          "items-start pt-2.5",
          headerShellHorizontalInsetClass,
          "gap-[80px] md:gap-[128px]",
          isIndexPage && "transition-opacity duration-[2500ms] ease-in-out",
          isIndexPage && (showContent ? "opacity-100" : "opacity-0")
        )}
      >
        <div className="inline-flex items-start">
          <Link
            to="/"
            className={cn(headerNavTextClass, "leading-none")}
            onClick={() => {
              if (typeof window !== "undefined" && location.pathname !== "/") {
                sessionStorage.setItem("fromNavigation", "true");
              }
            }}
          >
            Kurt Bauer, Photographer
          </Link>
        </div>
        <div className="inline-flex items-start">
          <Link
            to="/contact/"
            data-header-contact
            className={cn(headerNavTextClass, "leading-none")}
          >
            Contact
          </Link>
        </div>
      </header>
    </>
  );
};

export default Header;
